import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { eur } from "@/lib/constants";
import { Handshake, Phone, Mail } from "lucide-react";

export default function SubRentalsRecap({ eventId, refreshKey }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/events/${eventId}/sub-rentals`).then(({ data: d }) => setData(d)).catch(() => setData(null));
  }, [eventId, refreshKey]);
  if (!data || !data.suppliers.length) return null;
  return (
    <div data-testid="ev-subrentals" className="mb-6 space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 font-semibold text-foreground"><Handshake className="h-4 w-4 text-[#E6B800]" />À commander chez les prestataires</p>
        <span className="text-xs text-muted-foreground">
          {data.provisional ? "Provisoire — devis pas encore accepté" : "D'après"} {data.quote_numbers.filter(Boolean).join(", ")}
        </span>
      </div>
      {data.suppliers.map((g, i) => (
        <div key={g.supplier?.id || `none-${i}`} data-testid={`ev-subrental-${g.supplier?.id || "none"}`} className="rounded-xl border border-border bg-card p-4">
          <div className="flex flex-wrap items-start justify-between gap-2">
            <div>
              <p className="font-medium text-foreground">{g.supplier ? (g.supplier.company_name || g.supplier.name) : "Prestataire non renseigné"}</p>
              {g.supplier && (
                <div className="mt-0.5 flex flex-wrap gap-3 text-xs text-muted-foreground">
                  {g.supplier.phone && <a href={`tel:${g.supplier.phone}`} className="flex items-center gap-1 hover:text-[#FF6A00]"><Phone className="h-3 w-3" />{g.supplier.phone}</a>}
                  {g.supplier.email && <a href={`mailto:${g.supplier.email}`} className="flex items-center gap-1 hover:text-[#FF6A00]"><Mail className="h-3 w-3" />{g.supplier.email}</a>}
                </div>
              )}
            </div>
            {data.show_costs && (
              <div className="text-right text-xs text-muted-foreground">
                <p>Coût <span className="font-semibold text-foreground">{eur(g.total_cost)}</span></p>
                <p>Marge <span className={`font-semibold ${g.total_price - g.total_cost < 0 ? "text-red-500" : "text-emerald-500"}`}>{eur(g.total_price - g.total_cost)}</span></p>
              </div>
            )}
          </div>
          <div className="mt-3 divide-y divide-border text-sm">
            {g.items.map((r) => (
              <div key={r.item_id} className="flex justify-between py-1.5">
                <span className="text-foreground">{r.name} <span className="text-muted-foreground">× {r.quantity}</span></span>
                {data.show_costs && <span className="text-muted-foreground">{eur(r.total_cost)}</span>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
